export const resetPasswordModalData = {
  header: 'Reset User’s Password',
  subHeader: 'Enter the new password and then Repeat it to change the user’s password',
  body: 'Are you sure you want to reset the password for this user ?',
  subBody: 'Once Confirmed, You can’t undo this action anymore.',
  cancelText: 'back',
  confirmText: 'Yes, Reset',
  message: 'User’s Password has been Changed successfully',
}

export const changePasswordModalData = {
  header: 'Change password',
  subHeader: 'Enter the new password and then confirm it to change your password',
  body: 'Are you sure you want to change your password ?',
  subBody: 'Once Confirmed, You can’t undo this action anymore.',
  cancelText: 'back',
  confirmText: 'Yes, Change',
  message: 'Your Password has been Changed successfully',
}

export const userActiveStatesList = {
  title: 'Activate user',
  color: '#61CD8C',
  header: 'activate user',
  body: 'Are you sure you want to "Activate user" this user.',
  subBody: 'Are you sure you want to Active this user',
  finish: 'The user status has been "Activated" successfully',
  error: 'Could not "Activate user" this user',
  cancelText: 'Cancel',
  confirmText: 'Yes, Activate user',
}
export const userDeactivateStatesList = {
  title: 'De-activate User',
  color: '#fc5a5a',
  header: 'De-activate User',
  body: 'Are you sure you want to "Deactivate User" this user.',
  subBody: 'This will prevent the user from doing any assigned role, click yes to proceed the action or cancel the action',
  finish: 'The user status has been "De-activated" successfully',
  error: 'Could not "De-activate User" this user',
  cancelText: 'Cancel',
  confirmText: 'Yes, De-activate User',
}
